/**
 * Complete Authentic Arabic Translations for MyMenuBuddy Recipes (All 48 Dishes)
 */

export const STATE_ARABIC_MAP = {
  "Tamil Nadu": "تاميل نادو",
  "Tamil Nadu / South India": "تاميل نادو / جنوب الهند",
  "Kerala": "كيرلا",
  "Andhra Pradesh": "أندرا براديش",
  "Karnataka": "كارناتاكا",
  "Punjab": "البنجاب",
  "Maharashtra": "ماهاراشترا",
  "Delhi / Punjab": "دلهي / البنجاب",
  "North India": "شمال الهند",
  "Tamil Nadu / Kerala": "تاميل نادو / كيرلا",
  "Indo-Chinese": "هندي صيني",
  "West Bengal": "البنغال الغربية",
  "Punjab / Delhi": "البنجاب / دلهي",
  "India Healthy": "صحي هندي تقليدي",
  "Central Thailand": "تايلاند",
  "Kanto": "اليابان",
  "Beirut Governorate": "لبنان / الشرق الأوسط",
  "Central Mexico": "المكسيك",
  "Campania": "إيطاليا",
  "Lazio": "إيطاليا",
  "Global": "عالمي",
  "Tamil Nadu / Telangana": "تاميل نادو / تيلانجانا",
  "Kerala / Tamil Nadu": "كيرلا / تاميل نادو"
};

export const CUISINE_ARABIC_MAP = {
  "Tamil Nadu Breakfast": "إفطار تاميل نادو",
  "Tamil Nadu Traditional": "مطبخ تاميل نادو التقليدي",
  "Temple Style Breakfast": "إفطار المعبد التقليدي",
  "South Indian Breakfast": "إفطار جنوب الهند",
  "Kerala Syrian Christian": "مطبخ كيرلا التقليدي",
  "Andhra Breakfast": "إفطار أندرا الحار",
  "Karnataka Tiffin": "تيفين كارناتاكا",
  "Punjabi Breakfast": "إفطار بنجابي تقليدي",
  "Maharashtrian Breakfast": "إفطار ماهاراشترا",
  "Tamil Nadu Comfort Food": "وجبة تاميل نادو المحبوبة",
  "Kongunadu": "مطبخ كونغونادو التراثي",
  "Tirunelveli Traditional": "مطبخ تيرونلفيلي التراثي",
  "Chettinad Non-Veg": "مطبخ تشيتي ناد الشهي",
  "Royal Biryani": "برياني ملكي فاخر",
  "Coastal Seafood": "مأكولات بحرية ساحلية",
  "North Indian Dhaba": "مطبخ دابا شمال الهند",
  "Punjabi Comfort Food": "مطبخ البنجاب الأصيل",
  "Andhra Spicy": "مطبخ أندرا الحار الشهير",
  "North Indian Homestyle": "مطبخ منزلي شمال الهند",
  "Mughlai North Indian": "مطبخ مغولي هندي فاخر",
  "Street Tiffin Classic": "وجبات شوارع تيفين الكلاسيكية",
  "Italian Classic": "مطبخ إيطالي كلاسيكي",
  "Italian Pasta": "باستا إيطالية فاخرة",
  "Indo-Chinese": "مطبخ هندي صيني",
  "Indo-Chinese Non-Veg": "مأكولات هندية صينية غير نباتية",
  "Thai Street Food": "مأكولات شوارع تايلاند",
  "Japanese Ramen": "رامن ياباني أصيل",
  "Middle Eastern": "مطبخ الشرق الأوسط",
  "Mumbai Street Food": "مأكولات شوارع مومباي",
  "Punjabi Street Food": "مأكولات شوارع البنجاب",
  "Mexican Traditional": "مطبخ مكسيكي تقليدي",
  "Evening Tea Snack": "وجبات خفيفة لشاي المساء",
  "Kanyakumari Coastal": "مأكولات ساحل كانياكوماري",
  "Kerala Seafood Classic": "مأكولات بحرية كيرلا الكلاسيكية",
  "Kerala Non-Veg Breakfast": "إفطار كيرلا غير النباتي",
  "Kerala Traditional": "مطبخ كيرلا التقليدي",
  "Sadhya Classic": "وليمة الساديا الكيرلية",
  "High Protein Dinner": "عشاء غني بالبروتين",
  "Temple Snack & Tea Time": "حلوى المعبد وشاي الكرك",
  "Military Mess Classic": "مطبخ ميليتري ميس العسكري",
  "Wholesome Millet Classic": "أطباق الدخن الصحية المتكاملة",
  "Fiber Rich Breakfast": "إفطار غني بالألياف الصحية",
  "Madurai Street Food": "مأكولات شوارع مادوراي الشهيرة"
};

export const ARABIC_RECIPES = {
  "1": {
    "meal_ar": "إدلي طري بالبخار + سامبار بالخضار + شتني جوز الهند",
    "desc_ar": "أقراص إدلي قطنية ناعمة مطهوة على البخار مع سامبار الخضار الشهي وصلصة شتني جوز الهند الطازجة.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "إفطار تاميل نادو",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "إدلي طري بالبخار",
        "ingredients_ar": [
          [
            "أرز الإدلي",
            "2 cups"
          ],
          [
            "عدس أوراد",
            "1/2 cup"
          ],
          [
            "حلبة",
            "1 tsp"
          ],
          [
            "ملح",
            "1 tsp"
          ],
          [
            "ماء",
            "as needed"
          ]
        ],
        "quick_ar": "انقع الأرز والعدس 4 ساعات ثم اطحنهما|اتركه يتخمر 8 ساعات|اطبخ على البخار 10 دقائق"
      },
      {
        "name_ar": "سامبار الخضار الحار",
        "ingredients_ar": [
          [
            "عدس أصفر (تور دال)",
            "1/2 cup"
          ],
          [
            "بصل",
            "1.5 cups"
          ],
          [
            "طماطم",
            "1 chopped"
          ],
          [
            "عصير تمر هندي",
            "2 tbsp"
          ],
          [
            "بهارات سامبار",
            "1.5 tbsp"
          ],
          [
            "كركم",
            "1/4 tsp each"
          ],
          [
            "خردل",
            "for tempering"
          ],
          [
            "زيت",
            "1 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اسلق العدس جيداً|اطبخ الخضار مع التمر هندي وبهارات السامبار|أضف الطشة واتركه يغلي"
      },
      {
        "name_ar": "شتني جوز الهند الطازج",
        "ingredients_ar": [
          [
            "مبشور جوز الهند",
            "1 cup"
          ],
          [
            "حمص محمص مطحون",
            "2 tbsp"
          ],
          [
            "فلفل أخضر حار",
            "2 pcs"
          ],
          [
            "زنجبيل",
            "1/2 inch"
          ],
          [
            "خردل",
            "for tadka"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اطحن جوز الهند مع الحمص والفلفل الأخضر|أضف طشة الخردل وأوراق الكاري"
      }
    ]
  },
  "2": {
    "meal_ar": "دوسا مقرمشة بالسمن + سامبار + شتني طماطم",
    "desc_ar": "فطائر دوسا ذهبية مقرمشة محضرة بالسمن البلدي مع سامبار دافئ وشتني الطماطم والبصل المتبل.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "مطبخ تاميل نادو التقليدي",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "دوسا مقرمشة ذهبية",
        "ingredients_ar": [
          [
            "أرز",
            "2 cups"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ماء",
            "to adjust consistency"
          ]
        ],
        "quick_ar": "افرد العجينة على مقلاة ساخنة|أضف السمن على الأطراف|اطوها عندما تصبح ذهبية مقرمشة"
      },
      {
        "name_ar": "شتني الطماطم الحار",
        "ingredients_ar": [
          [
            "طماطم",
            "2 chopped"
          ],
          [
            "بصل",
            "1 chopped"
          ],
          [
            "ثوم",
            "4 cloves"
          ],
          [
            "فلفل أحمر مجفف",
            "4 pcs"
          ],
          [
            "خردل",
            "for tadka"
          ],
          [
            "زيت سمسم",
            "1.5 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اقلِ البصل والطماطم والفلفل المجفف بالزيت|اطحن الخليط مع الملح وأضف الطشة"
      }
    ]
  },
  "3": {
    "meal_ar": "فين بونغال بالسمن + فادا مقرمشة + سامبار",
    "desc_ar": "طبق بونغال الأرز والعدس التقليدي الغني بالسمن والكاجو والفلفل الأسود مع فادا مقرمشة وسامبار المعبد.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "إفطار المعبد التقليدي",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "فين بونغال بالسمن",
        "ingredients_ar": [
          [
            "أرز أبيض",
            "1 cup"
          ],
          [
            "عدس ماش أصفر",
            "1/2 cup roasted"
          ],
          [
            "سمن بلدي نقي",
            "4 tbsp"
          ],
          [
            "فلفل أسود",
            "1 tbsp"
          ],
          [
            "بذور الكمون",
            "1 tbsp"
          ],
          [
            "زنجبيل",
            "1 tbsp finely minced"
          ],
          [
            "كاجو",
            "12 pcs"
          ],
          [
            "حلتيت",
            "handful & 1/4 tsp"
          ],
          [
            "ماء",
            "4.5 cups"
          ],
          [
            "ملح",
            "1.5 tsp"
          ]
        ],
        "quick_ar": "اسلق الأرز والعدس حتى ينضجا تماماً|حمّص الكاجو والفلفل والكمون بالسمن|اخلط الطشة مع البونغال"
      },
      {
        "name_ar": "فادا مقرمشة",
        "ingredients_ar": [
          [
            "عدس أوراد",
            "1 cup"
          ],
          [
            "زنجبيل",
            "1 tsp each minced"
          ],
          [
            "فلفل أسود",
            "1 tsp"
          ],
          [
            "حلتيت",
            "1 sprig & pinch"
          ],
          [
            "زيت",
            "2 cups"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اطحن عدس الأوراد بقوام كثيف|أضف الفلفل والكاري وشكّلها بحفرة بالوسط|اقلها بالزيت الساخن حتى تقرمش"
      }
    ]
  },
  "4": {
    "meal_ar": "بوري مقلي منفوخ + إيدام بطاطس ماسالا",
    "desc_ar": "أقراص خبز بوري ذهبية منتفخة مع إيدام بطاطس ماسالا الشهي على طريقة مطاعم جنوب الهند.",
    "state_ar": "تاميل نادو / جنوب الهند",
    "cuisine_ar": "إفطار جنوب الهند",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "بوري مقلي منفوخ",
        "ingredients_ar": [
          [
            "دقيق قمح",
            "2 cups"
          ],
          [
            "سميد",
            "1 tbsp for crispiness"
          ],
          [
            "ماء",
            "3/4 cup"
          ],
          [
            "زيت",
            "2 cups"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اعجن دقيق القمح جيداً|افرد دوائر صغيرة رقيقة|اقلها بالزيت الساخن حتى تنتفخ وتصبح ذهبية"
      },
      {
        "name_ar": "إيدام بطاطس ماسالا للمطاعم",
        "ingredients_ar": [
          [
            "زيت",
            "3 large"
          ],
          [
            "بصل",
            "2 sliced"
          ],
          [
            "فلفل أخضر حار",
            "3 slit"
          ],
          [
            "زنجبيل",
            "1 tbsp minced"
          ],
          [
            "Besan (Gram Flour)",
            "1 tbsp dissolved in 1/4 cup water"
          ],
          [
            "كركم",
            "1/2 tsp"
          ],
          [
            "عدس أوراد",
            "1/2 tsp each"
          ],
          [
            "أوراق كاري",
            "handful"
          ],
          [
            "زيت",
            "1.5 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "حمّص البصل والفلفل الحار والكركم بالزيت|أضف البطاطس المسلوقة المهروسة|أضف دقيق الحمص المذاب بالماء حتى يثخن"
      }
    ]
  },
  "5": {
    "meal_ar": "آيام كيرلا الرقيق + يخنة خضار بحليب جوز الهند",
    "desc_ar": "فطائر آبام التقليدية المخمرة ذات الحواف المقرمشة والوسط الطري مع يخنة خضار غنية بحليب جوز الهند.",
    "state_ar": "كيرلا",
    "cuisine_ar": "مطبخ كيرلا التقليدي",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "فطائر بالابام الناعمة",
        "ingredients_ar": [
          [
            "أرز أبيض",
            "2 cups soaked"
          ],
          [
            "مبشور جوز الهند",
            "1 cup"
          ],
          [
            "أرز مطبوخ",
            "1/2 cup"
          ],
          [
            "Yeast",
            "1/2 tsp"
          ],
          [
            "ملح",
            "1 tbsp & 1/2 tsp"
          ]
        ],
        "quick_ar": "اطحن الأرز مع جوز الهند وخمره|افرد العجينة في مقلاة آبام الدائرية|غطها واطبخ على البخار دقيقتين"
      },
      {
        "name_ar": "يخنة خضار بحليب جوز الهند",
        "ingredients_ar": [
          [
            "بطاطس",
            "2 cups"
          ],
          [
            "حليب",
            "1 cup & 2 cups"
          ],
          [
            "بصل",
            "1 sliced, 1 tbsp minced, 3 slit"
          ],
          [
            "هيل",
            "few"
          ],
          [
            "زيت جوز الهند",
            "2 tbsp"
          ],
          [
            "فلفل أسود",
            "handful & 1/2 tsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "حمّص البهارات والزنجبيل والبصل بالزيت|اسلق الخضار بحليب جوز الهند الخفيف|أضف الحليب المركز وارفع عن النار"
      }
    ]
  },
  "6": {
    "meal_ar": "بيساراتو أندرا بالعدس الأخضر + شتني الزنجبيل",
    "desc_ar": "فطائر بيساراتو أندرا الغنية بالبروتين والمصنوعة من حبوب الماش الأخضر مع شتني الزنجبيل الحار.",
    "state_ar": "أندرا براديش",
    "cuisine_ar": "إفطار أندرا الحار",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "بيساراتو العدس الأخضر المقرمش",
        "ingredients_ar": [
          [
            "عدس ماش أصفر",
            "2 cups"
          ],
          [
            "أرز",
            "2 tbsp"
          ],
          [
            "زنجبيل",
            "3 pcs & 1 inch"
          ],
          [
            "بصل",
            "1/2 cup & 1 tsp for topping"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اطحن الماش الأخضر مع الزنجبيل والفلفل|افرد العجينة على صاج ساخن|رش البصل والكمون واشوها حتى تقرمش"
      },
      {
        "name_ar": "شتني الزنجبيل الحار",
        "ingredients_ar": [
          [
            "زنجبيل",
            "1/2 cup"
          ],
          [
            "عصير تمر هندي",
            "3 tbsp"
          ],
          [
            "سكر القصب (جاغري)",
            "3 tbsp"
          ],
          [
            "فلفل أحمر مجفف",
            "4 pcs"
          ],
          [
            "عدس أوراد",
            "1 tbsp each"
          ],
          [
            "زيت",
            "for tadka"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اقلِ الزنجبيل والتمر هندي والجاغري والفلفل|اطحن الخليط ناعماً وأضف طشة الخردل"
      }
    ]
  },
  "7": {
    "meal_ar": "أوبما السميد بالخضار + شتني جوز الهند",
    "desc_ar": "إفطار أوبما السميد المحمص بالخضار والتوابل والمكسرات مع شتني جوز الهند المنعش.",
    "state_ar": "كارناتاكا",
    "cuisine_ar": "تيفين كارناتاكا",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "أوبما السميد بالخضار",
        "ingredients_ar": [
          [
            "سميد",
            "1 cup"
          ],
          [
            "ماء",
            "2.5 cups"
          ],
          [
            "بصل",
            "1 cup chopped"
          ],
          [
            "زنجبيل",
            "1 tsp each minced"
          ],
          [
            "خردل",
            "10 pcs & 1 tsp"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "أوراق كاري",
            "handful"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "حمّص السميد بالسمن|اقلِ البهارات والخضار واغلِ الماء|أضف السميد بالتدريج مع التقليب المستمر"
      }
    ]
  },
  "8": {
    "meal_ar": "باراثا البطاطس المتبلة + زبادي رائب + زبدة",
    "desc_ar": "خبز باراثا بنجابي محشو بالبطاطس المتبلة بالأعشاب والبهارات يُقدم مع زبادي رائب وقطعة زبدة طازجة.",
    "state_ar": "البنجاب",
    "cuisine_ar": "إفطار بنجابي تقليدي",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "باراثا البطاطس المتبلة",
        "ingredients_ar": [
          [
            "دقيق قمح",
            "2 cups"
          ],
          [
            "زيت",
            "3 large"
          ],
          [
            "زنجبيل",
            "finely chopped"
          ],
          [
            "جرام ماسالا",
            "1/2 tsp each"
          ],
          [
            "سمن بلدي",
            "3 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "تبّل البطاطس المهروسة بالتوابل والكزبرة|احشها داخل عجينة القمح وافردها|اشوها على الصاج مع السمن أو الزبدة"
      },
      {
        "name_ar": "زبادي بارد وزبدة",
        "ingredients_ar": [
          [
            "زبادي رائب",
            "1 cup"
          ],
          [
            "زبدة",
            "1 generous dollop"
          ],
          [
            "ملح",
            "pinch for dusting"
          ]
        ],
        "quick_ar": "قدمه مع زبادي رائب مثلج وقطعة زبدة بلدية طازجة"
      }
    ]
  },
  "9": {
    "meal_ar": "بوها رقائق الأرز بالبصل + سيف مقرمش + ليمون",
    "desc_ar": "وجبة بوها الخفيفة من رقائق الأرز المحمصة مع البصل والفول السوداني والكركم ومزينة بالسيف المقرمش.",
    "state_ar": "ماهاراشترا",
    "cuisine_ar": "إفطار ماهاراشترا",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "بوها البصل والبطاطس",
        "ingredients_ar": [
          [
            "أرز",
            "2 cups rinsed and drained"
          ],
          [
            "بصل",
            "1.5 cups chopped"
          ],
          [
            "بطاطس",
            "1 boiled/fried"
          ],
          [
            "فول سوداني",
            "3 tbsp"
          ],
          [
            "كمون",
            "1/2 tsp each"
          ],
          [
            "فلفل أخضر حار",
            "3 slit & 1 sprig"
          ],
          [
            "كركم",
            "1/2 tsp & 1/2 tsp"
          ],
          [
            "ليمون",
            "for garnish"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اغسل رقائق الأرز وصَفّها|اقلِ الفول السوداني والبصل والبطاطس والكركم|اخلط البوها مع الليمون والكزبرة"
      }
    ]
  },
  "10": {
    "meal_ar": "أرز السامبار التقليدي + بطاطس مشوية مقرمشة + بابادوم",
    "desc_ar": "وجبة أرز مطهو في مرق السامبار والخضار بالسمن البلدي مع بطاطس مشوية حارة ومقرمشات بابادوم.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "وجبة تاميل نادو المحبوبة",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "أرز السامبار في قدر واحد",
        "ingredients_ar": [
          [
            "أرز",
            "1 cup"
          ],
          [
            "عدس أصفر (تور دال)",
            "1/2 cup"
          ],
          [
            "Mixed Vegetables",
            "1.5 cups"
          ],
          [
            "عصير تمر هندي",
            "3 tbsp"
          ],
          [
            "بهارات سامبار",
            "2 tbsp"
          ],
          [
            "كركم",
            "1/4 tsp each"
          ],
          [
            "سمن بلدي نقي",
            "3 tbsp"
          ],
          [
            "خردل",
            "for tadka"
          ],
          [
            "ماء",
            "4.5 cups"
          ],
          [
            "ملح",
            "1.5 tsp"
          ]
        ],
        "quick_ar": "اطبخ الأرز والعدس والخضار بالقدر|أضف بهارات السامبار والتمر هندي والسمن|أضف الطشة الساخنة واخلط جيداً"
      },
      {
        "name_ar": "بطاطس مشوية حارة ومقرمشة",
        "ingredients_ar": [
          [
            "بطاطس",
            "2 large"
          ],
          [
            "بهارات سامبار",
            "1 tsp each"
          ],
          [
            "أوراق كاري",
            "1/2 tsp & 1 sprig"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "تبّل مكعبات البطاطس بالفلفل الحار والكركم|حمرها في المقلاة بالزيت على نار هادئة حتى تقرمش"
      },
      {
        "name_ar": "مقرمشات بابادوم مقلية",
        "ingredients_ar": [
          [
            "عدس أوراد",
            "4 pcs"
          ],
          [
            "زيت",
            "1 cup"
          ]
        ],
        "quick_ar": "اقلِ رقائق البابادوم بالزيت الساخن لثوانٍ حتى تنتفخ"
      }
    ]
  },
  "11": {
    "meal_ar": "أرز الرسام الحار + بطاطس مقلية + بابادوم",
    "desc_ar": "حساء رسام الطماطم والفلفل الأسود والكمون المنعش مع أرز أبيض وبطاطس مقلية ذهبية.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "وجبة تاميل نادو المحبوبة",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "رسام الطماطم بالفلفل الأسود",
        "ingredients_ar": [
          [
            "طماطم",
            "2 mashed"
          ],
          [
            "عصير تمر هندي",
            "2 tbsp"
          ],
          [
            "كمون",
            "1 tbsp each crushed"
          ],
          [
            "ثوم",
            "6 cloves crushed"
          ],
          [
            "كركم",
            "1/4 tsp each"
          ],
          [
            "خردل",
            "for tadka"
          ],
          [
            "سمن بلدي",
            "1 tbsp"
          ],
          [
            "ماء",
            "2.5 cups"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اغلِ الطماطم مع ماء التمر هندي|أضف مدقوق الفلفل والكمون والثوم والكزبرة|اطفئ النار فور الغليان وأضف الطشة"
      },
      {
        "name_ar": "بطاطس مقلية مقرمشة",
        "ingredients_ar": [
          [
            "بطاطس",
            "2 sliced"
          ],
          [
            "Chilli Powder",
            "1 tsp"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اقلِ شرائح البطاطس بالزيت والتوابل حتى تصبح مقرمشة"
      },
      {
        "name_ar": "أرز على البخار وبابادوم",
        "ingredients_ar": [
          [
            "أرز",
            "1.5 cups"
          ],
          [
            "مقرمشات بابادوم",
            "4 pcs"
          ],
          [
            "ماء",
            "for cooking & frying"
          ]
        ],
        "quick_ar": "أرز أبيض ساخن مطهو على البخار"
      }
    ]
  },
  "12": {
    "meal_ar": "أرز بالزبادي المنعش (تاير سادام) + بطاطس مقلية + مخلل",
    "desc_ar": "أرز الزبادي الكريمي المتبل بأوراق الكاري والخردل على طريقة المعابد مع بطاطس مقلية ومخلل.",
    "state_ar": "تاميل نادو / جنوب الهند",
    "cuisine_ar": "وجبة تاميل نادو المحبوبة",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "أرز بالزبادي على طريقة المعابد",
        "ingredients_ar": [
          [
            "أرز",
            "1.5 cups"
          ],
          [
            "زبادي رائب",
            "1 cup"
          ],
          [
            "حليب",
            "1/2 cup"
          ],
          [
            "زبدة",
            "1 tbsp"
          ],
          [
            "زنجبيل",
            "1 tsp each minced"
          ],
          [
            "عدس أوراد",
            "1/2 tsp each"
          ],
          [
            "حلتيت",
            "1 pinch"
          ],
          [
            "أوراق كاري",
            "handful"
          ],
          [
            "زيت",
            "1 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اهرس الأرز الساخن جيداً|اخلطه مع الزبادي والحليب والملح|أضف طشة الخردل والزنجبيل وأوراق الكاري"
      },
      {
        "name_ar": "بطاطس مقلية مقرمشة",
        "ingredients_ar": [
          [
            "بطاطس",
            "2 sliced"
          ],
          [
            "بهارات سامبار",
            "1 tsp each"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اقلِ شرائح البطاطس بالزيت والتوابل حتى تصبح مقرمشة"
      }
    ]
  },
  "13": {
    "meal_ar": "أرز العدس على طريقة كونغو + بطاطس مقلية",
    "desc_ar": "طبق أرز وعدس تقليدي من ريف كونغونادو مطهو بالسمن والتوابل مع بطاطس مقلية مقرمشة.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "مطبخ كونغونادو التراثي",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "أرز العدس على طريقة كونغو",
        "ingredients_ar": [
          [
            "أرز",
            "1 cup"
          ],
          [
            "عدس أصفر (تور دال)",
            "1/3 cup"
          ],
          [
            "بصل شالوت صغير",
            "12 sliced"
          ],
          [
            "ثوم",
            "6 cloves"
          ],
          [
            "طماطم",
            "1 chopped"
          ],
          [
            "بهارات سامبار",
            "1 tsp"
          ],
          [
            "سمن بلدي",
            "2 tbsp"
          ],
          [
            "كمون",
            "for tadka"
          ],
          [
            "ماء",
            "3 cups"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "حمّص البهارات والبصل والطماطم بالسمن|أضف الأرز والعدس وبهار السامبار والماء|اطبخه بالقدر حتى ينضج وزينه بالسمن"
      },
      {
        "name_ar": "بطاطس مقلية مقرمشة",
        "ingredients_ar": [
          [
            "بطاطس",
            "2 cubed"
          ],
          [
            "Chilli Powder",
            "1 tsp"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اقلِ شرائح البطاطس بالزيت والتوابل حتى تصبح مقرمشة"
      }
    ]
  },
  "14": {
    "meal_ar": "يخنة نيلاي بحليب جوز الهند + أرز أبيض + بطاطس محمصة",
    "desc_ar": "يخنة صودي الفاخرة بحليب جوز الهند الطازج والخضار مع أرز ساخن وصلصة الزنجبيل الحامضة.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "مطبخ تيرونلفيلي التراثي",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "يخنة صودي بحليب جوز الهند",
        "ingredients_ar": [
          [
            "عدس ماش أصفر",
            "1/2 cup"
          ],
          [
            "حليب",
            "1 cup & 2 cups"
          ],
          [
            "بطاطس",
            "1.5 cups"
          ],
          [
            "بصل شالوت صغير",
            "10 sliced & 4 slit"
          ],
          [
            "زنجبيل",
            "1 tbsp & 1.5 tbsp"
          ],
          [
            "زيت جوز الهند",
            "2 tbsp"
          ],
          [
            "خردل",
            "for tadka"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اسلق الخضار بحليب جوز الهند الخفيف|أضف معجون العدس وحليب جوز الهند الثقيل|ارفع عن النار وأضف عصير الليمون"
      },
      {
        "name_ar": "صلصة الزنجبيل والتمر هندي (إنجي بولي)",
        "ingredients_ar": [
          [
            "زنجبيل",
            "1/2 cup"
          ],
          [
            "تمر هندي",
            "1/2 cup"
          ],
          [
            "سكر القصب (جاغري)",
            "2 tbsp"
          ],
          [
            "كركم",
            "1 tsp & 1/4 tsp"
          ],
          [
            "زيت",
            "for tadka"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اقلِ شرائح الزنجبيل بالزيت|اطبخها مع معجون التمر هندي والجاغري والفلفل حتى تتكثف"
      },
      {
        "name_ar": "بطاطس مشوية وأرز",
        "ingredients_ar": [
          [
            "بطاطس",
            "2 cubed"
          ],
          [
            "أرز",
            "1.5 cups"
          ],
          [
            "زيت",
            "for cooking"
          ]
        ],
        "quick_ar": "بطاطس مقرمشة متبلة تقدم مع أرز أبيض ساخن"
      }
    ]
  },
  "15": {
    "meal_ar": "دجاج تشيتي ناد بالفلفل الأسود + أرز رسام + بطاطس",
    "desc_ar": "قطع دجاج تشوكا المحمصة بتوابل تشيتي ناد والفلفل الأسود المطحون طازجاً مع أرز وحساء رسام الثوم.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "مطبخ تشيتي ناد الشهي",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "دجاج تشيتي ناد بالفلفل الأسود",
        "ingredients_ar": [
          [
            "قطع دجاج",
            "500g"
          ],
          [
            "بصل شالوت صغير",
            "15 sliced"
          ],
          [
            "فلفل أسود",
            "1.5 tbsp"
          ],
          [
            "Coriander Seeds",
            "1 tbsp"
          ],
          [
            "كمون",
            "1 tsp each"
          ],
          [
            "فلفل أحمر مجفف",
            "4 pcs"
          ],
          [
            "معجون زنجبيل وثوم",
            "1 tbsp"
          ],
          [
            "زيت سمسم",
            "3 tbsp"
          ],
          [
            "أوراق كاري",
            "3 sprigs"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اطبخ الدجاج مع التوابل الأساسية|حمّصه في مقلاة واسعة مع الفلفل الأسود والبصل حتى يجف تماماً"
      },
      {
        "name_ar": "حساء رسام الثوم والفلفل",
        "ingredients_ar": [
          [
            "ثوم",
            "8 cloves"
          ],
          [
            "كمون",
            "1 tbsp each crushed"
          ],
          [
            "طماطم",
            "1 mashed"
          ],
          [
            "ماء",
            "1.5 cups"
          ],
          [
            "كركم",
            "1/4 tsp each"
          ],
          [
            "سمن بلدي",
            "1 tsp"
          ],
          [
            "خردل",
            "for tadka"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اطحن الثوم والفلفل والكمون واغله مع مرق التمر هندي وأوراق الكاري"
      },
      {
        "name_ar": "بطاطس مشوية حارة",
        "ingredients_ar": [
          [
            "بطاطس",
            "2 cubed"
          ],
          [
            "بهارات سامبار",
            "1 tsp each"
          ],
          [
            "أوراق كاري",
            "1/2 tsp & 1 sprig"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "مكعبات بطاطس مقرمشة محمرة بالزيت والبهارات"
      },
      {
        "name_ar": "أرز أبيض ساخن",
        "ingredients_ar": [
          [
            "أرز",
            "1.5 cups"
          ],
          [
            "ماء",
            "3.5 cups"
          ]
        ],
        "quick_ar": "أرز أبيض مطهو على البخار"
      }
    ]
  },
  "16": {
    "meal_ar": "برياني الدجاج الملكي + رايتا البصل + صلصة الباذنجان",
    "desc_ar": "برياني دجاج دوم الفاخر بأرز البسمتي العطري والزعفران يُقدم مع صلصة سالان الباذنجان ورايتا الزبادي.",
    "state_ar": "تاميل نادو / تيلانجانا",
    "cuisine_ar": "برياني ملكي فاخر",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "برياني دجاج دوم الفاخر",
        "ingredients_ar": [
          [
            "أرز",
            "2 cups"
          ],
          [
            "قطع دجاج",
            "600g"
          ],
          [
            "بصل",
            "3 large"
          ],
          [
            "معجون زنجبيل وثوم",
            "2 tbsp"
          ],
          [
            "فلفل أخضر حار",
            "5 pcs"
          ],
          [
            "زبادي رائب",
            "1/2 cup"
          ],
          [
            "جرام ماسالا",
            "1.5 tsp"
          ],
          [
            "كركم",
            "1.5 tsp & 1/2 tsp"
          ],
          [
            "Mint & Coriander",
            "1 cup chopped"
          ],
          [
            "زيت",
            "3 tbsp each"
          ],
          [
            "ملح",
            "2 tsp"
          ]
        ],
        "quick_ar": "تبل الدجاج بالزبادي والبهارات والنعناع|ضع طبقات من أرز البسمتي نصف المسلوق|احكم إغلاق القدر واطبخه على نار هادئة 25 دقيقة"
      },
      {
        "name_ar": "إيدام الباذنجان الخاص بالبرياني",
        "ingredients_ar": [
          [
            "باذنجان",
            "4 slit"
          ],
          [
            "فول سوداني",
            "2 tbsp each roasted & ground"
          ],
          [
            "عصير تمر هندي",
            "2 tbsp"
          ],
          [
            "بصل",
            "1 chopped"
          ],
          [
            "بهارات سامبار",
            "1.5 tsp"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اقلِ حبات الباذنجان الصغيرة|اطبخها في مرق السمسم والفول السوداني والتمر هندي"
      },
      {
        "name_ar": "رايتا البصل المنعشة",
        "ingredients_ar": [
          [
            "زبادي رائب",
            "1 cup"
          ],
          [
            "بصل",
            "1 finely sliced"
          ],
          [
            "Green Chilli & Coriander",
            "1 tsp each"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اخلط البصل المفروم والفلفل الأخضر والكزبرة مع الزبادي البارد ورشة كمون"
      }
    ]
  },
  "17": {
    "meal_ar": "كاري السمك الجنوبي التمر هندي + أرز أبيض + سمك مقلي",
    "desc_ar": "كاري سمك قروي أصيل مطهو بالفخار مع التمر هندي وحليب جوز الهند وسمك مقلي متبل مقرمش.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "مأكولات بحرية ساحلية",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "كاري سمك مدراس القروي",
        "ingredients_ar": [
          [
            "سمك",
            "500g"
          ],
          [
            "بصل شالوت صغير",
            "15 peeled"
          ],
          [
            "ثوم",
            "10 cloves"
          ],
          [
            "طماطم",
            "2 pureed"
          ],
          [
            "عصير تمر هندي",
            "4 tbsp"
          ],
          [
            "بهارات سامبار",
            "2.5 tbsp"
          ],
          [
            "حلبة",
            "1/4 tsp & 1/2 tsp"
          ],
          [
            "خردل",
            "for tempering"
          ],
          [
            "زيت سمسم",
            "3 tbsp"
          ],
          [
            "ملح",
            "1.5 tsp"
          ]
        ],
        "quick_ar": "حمّص البصل الصغير والطماطم في قدر فخاري|أضف مرق التمر هندي والبهارات واغله|أضف قطع السمك واطبخ 7 دقائق حتى تنضج"
      },
      {
        "name_ar": "سمك مقلي متبل مقرمش",
        "ingredients_ar": [
          [
            "سمك",
            "300g"
          ],
          [
            "Chilli Powder",
            "1.5 tsp"
          ],
          [
            "كركم",
            "1/2 tsp each"
          ],
          [
            "زنجبيل",
            "1 tbsp & 1 tsp"
          ],
          [
            "أرز",
            "1 tbsp"
          ],
          [
            "زيت",
            "3 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "تبّل شرائح السمك بالكركم والليمون والفلفل الحار|اشوها في مقلاة مع القليل من الزيت حتى تقرمش"
      },
      {
        "name_ar": "أرز أبيض ساخن",
        "ingredients_ar": [
          [
            "أرز",
            "1.5 cups"
          ],
          [
            "ماء",
            "3.5 cups"
          ]
        ],
        "quick_ar": "أرز أبيض مطهو على البخار"
      }
    ]
  },
  "18": {
    "meal_ar": "دال تادكا بالعدس الأصفر + أرز بالكمون + بطاطس وقرنبيط",
    "desc_ar": "شوربة عدس أصفر غنية بطشة الثمن والكمون مع أرز بسمتي بالكمون وإيدام بطاطس وقرنبيط جاف.",
    "state_ar": "دلهي / البنجاب",
    "cuisine_ar": "مطبخ دابا شمال الهند",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "عدس أصفر بطشة مزدوجة",
        "ingredients_ar": [
          [
            "عدس أصفر (تور دال)",
            "1 cup boiled with turmeric"
          ],
          [
            "ثوم",
            "8 cloves"
          ],
          [
            "بصل",
            "1 each chopped"
          ],
          [
            "سمن بلدي",
            "2.5 tbsp"
          ],
          [
            "كمون",
            "1 tsp & 1/4 tsp"
          ],
          [
            "فلفل أحمر مجفف",
            "2 pcs & 1 tsp"
          ],
          [
            "حلبة مجففة",
            "1 tsp & handful"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اسلق العدس حتى يصبح ناعماً|أضف طشة أولى من السمن والثوم والكمون|أضف طشة ثانية من مسحوق الفلفل الحار والكزبرة"
      },
      {
        "name_ar": "إيدام بطاطس وقرنبيط جاف",
        "ingredients_ar": [
          [
            "بطاطس",
            "1.5 cups each cubed & florets"
          ],
          [
            "زنجبيل",
            "1 tbsp"
          ],
          [
            "كركم",
            "1/2 tsp, 1 tsp & 1/2 tsp"
          ],
          [
            "بذور الكمون",
            "1 tsp"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "شوح البطاطس وزهرات القرنبيط مع الزنجبيل والتوابل واطبخ مغطى حتى ينضج"
      },
      {
        "name_ar": "أرز بسمتي بالكمون العطري",
        "ingredients_ar": [
          [
            "أرز بسمتي",
            "1.5 cups"
          ],
          [
            "بذور الكمون",
            "1.5 tbsp"
          ],
          [
            "سمن بلدي",
            "2 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "حمّص بذور الكمون والبهارات بالسمن واخلطها مع أرز البسمتي المطبوخ"
      }
    ]
  },
  "19": {
    "meal_ar": "راجما الفاصوليا الحمراء البنجابية + أرز بسمتي + سلطة",
    "desc_ar": "فاصوليا حمراء مطهوة بمرق الطماطم والبصل الغني مع أرز بسمتي على البخار وسلطة كاشومبار.",
    "state_ar": "البنجاب",
    "cuisine_ar": "مطبخ البنجاب الأصيل",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "راجما الفاصوليا الحمراء البنجابية",
        "ingredients_ar": [
          [
            "فاصوليا خضراء",
            "1.5 cups"
          ],
          [
            "بصل",
            "2 large"
          ],
          [
            "طماطم",
            "2 cups"
          ],
          [
            "معجون زنجبيل وثوم",
            "1.5 tbsp"
          ],
          [
            "جرام ماسالا",
            "1.5 tbsp"
          ],
          [
            "مسحوق كزبرة",
            "1 tbsp each"
          ],
          [
            "سمن بلدي",
            "2 tbsp"
          ],
          [
            "حلبة مجففة",
            "1 tsp"
          ],
          [
            "ملح",
            "1.5 tsp"
          ]
        ],
        "quick_ar": "اسلق الفاصوليا الحمراء حتى تلين|اطبخها في صلصة طماطم وبصل غنية بالبهارات البنجابية"
      },
      {
        "name_ar": "أرز بسمتي على البخار وسلطة",
        "ingredients_ar": [
          [
            "أرز بسمتي",
            "1.5 cups"
          ],
          [
            "بصل",
            "1 cup"
          ],
          [
            "ليمون",
            "1 tbsp & 1/2 tsp"
          ]
        ],
        "quick_ar": "أرز بسمتي طويل الحبة مع سلطة بصل وخيار طازجة"
      }
    ]
  },
  "20": {
    "meal_ar": "كاري الدجاج الحار على طريقة أندرا + أرز أبيض",
    "desc_ar": "كاري دجاج جونتور الشهير بتوابله الحارة الغنية ولمسة السمن البلدي مع أرز ساخن.",
    "state_ar": "أندرا براديش",
    "cuisine_ar": "مطبخ أندرا الحار الشهير",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "كاري دجاج جونتور الحار",
        "ingredients_ar": [
          [
            "قطع دجاج",
            "600g"
          ],
          [
            "بصل",
            "2 large"
          ],
          [
            "معجون زنجبيل وثوم",
            "2 tbsp"
          ],
          [
            "مسحوق فلفل أحمر",
            "2 tbsp"
          ],
          [
            "كمون",
            "1.5 tbsp & 1 tsp ground"
          ],
          [
            "جوز الهند",
            "1 tbsp each ground to paste"
          ],
          [
            "جرام ماسالا",
            "1 tsp"
          ],
          [
            "أوراق كاري",
            "3 sprigs"
          ],
          [
            "زيت",
            "3 tbsp"
          ],
          [
            "ملح",
            "1.5 tsp"
          ]
        ],
        "quick_ar": "شوح قطع الدجاج مع البصل ومعجون الزنجبيل والثوم|أضف مسحوق فلفل جونتور الحار والماء واطبخ حتى ينضج"
      },
      {
        "name_ar": "أرز ساخن وسمن بلدي",
        "ingredients_ar": [
          [
            "أرز",
            "1.5 cups"
          ],
          [
            "سمن بلدي نقي",
            "1 tbsp"
          ]
        ],
        "quick_ar": "أرز أبيض ساخن مزين بملعقة سمن بلدي نقي"
      }
    ]
  },
  "21": {
    "meal_ar": "خبز شباتي + بانير بالزبدة والصلصة الغنية",
    "desc_ar": "أقراص خبز شباتي رقيقة طازجة مع قطع جبن البانير المطهوة بصلصة الطماطم والكريمة الغنية.",
    "state_ar": "شمال الهند",
    "cuisine_ar": "مطبخ منزلي شمال الهند",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "خبز فولكا طري",
        "ingredients_ar": [
          [
            "دقيق قمح",
            "2 cups"
          ],
          [
            "ماء",
            "3/4 cup"
          ],
          [
            "زيت",
            "1 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "افرد العجينة رقيقة واشوها على الصاج والنار المباشرة حتى تنتفخ"
      },
      {
        "name_ar": "بانير بصلصة الزبدة والكريمة",
        "ingredients_ar": [
          [
            "جبن بانير",
            "250g"
          ],
          [
            "طماطم",
            "2 cups"
          ],
          [
            "بصل",
            "1 finely chopped"
          ],
          [
            "Cashew Paste",
            "10 cashews blended"
          ],
          [
            "معجون زنجبيل وثوم",
            "1 tbsp"
          ],
          [
            "زبدة",
            "3 tbsp & 2 tbsp"
          ],
          [
            "Kashmiri Chilli Powder",
            "1.5 tsp"
          ],
          [
            "جرام ماسالا",
            "1/2 tsp & 1 tsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اطبخ صلصة الطماطم والكاجو الناعمة بالزبدة|أضف مكعبات جبن البانير والكريمة والحلبة المجففة"
      }
    ]
  },
  "22": {
    "meal_ar": "دجاج بالزبدة الهندي (بتر تشيكن) + خبز نان بالثوم + أرز كمون",
    "desc_ar": "دجاج بتر تشيكن الشهير بصلصته المخملية الغنية بالزبدة مع خبز نان بالثوم المشوي وأرز كمون.",
    "state_ar": "دلهي / البنجاب",
    "cuisine_ar": "مطبخ مغولي هندي فاخر",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "دجاج بالزبدة على طريقة المطاعم",
        "ingredients_ar": [
          [
            "قطع دجاج",
            "500g"
          ],
          [
            "زبادي رائب",
            "1/2 cup"
          ],
          [
            "معجون زنجبيل وثوم",
            "2 tbsp"
          ],
          [
            "Kashmiri Chilli Powder",
            "2 tbsp"
          ],
          [
            "طماطم",
            "2 cups"
          ],
          [
            "Cashew Paste",
            "15 cashews blended"
          ],
          [
            "زبدة",
            "4 tbsp"
          ],
          [
            "كريمة طازجة",
            "3 tbsp"
          ],
          [
            "حلبة مجففة",
            "1 tbsp"
          ],
          [
            "جرام ماسالا",
            "1 tsp each"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اطبخ قطع الدجاج المشوية في صلصة الطماطم والزبدة المخملية|أضف الكريمة والكاسوري ميثي"
      },
      {
        "name_ar": "خبز نان بالثوم والزبدة",
        "ingredients_ar": [
          [
            "دقيق أبيض",
            "2 cups"
          ],
          [
            "زبادي رائب",
            "3 tbsp"
          ],
          [
            "Baking Powder & Soda",
            "1/2 tsp & 1/4 tsp"
          ],
          [
            "ثوم",
            "2 tbsp"
          ],
          [
            "زبدة",
            "3 tbsp & 1 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "افرد عجينة النان ورش الثوم والكزبرة|اشوها في المقلاة وادهنها بالزبدة الساخنة"
      },
      {
        "name_ar": "أرز بالكمون",
        "ingredients_ar": [
          [
            "أرز بسمتي",
            "1.5 cups"
          ],
          [
            "بذور الكمون",
            "1.5 tbsp"
          ],
          [
            "سمن بلدي",
            "2 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "أرز بسمتي ناصع متبل بالكمون والسمن"
      }
    ]
  },
  "23": {
    "meal_ar": "بروتا مالابار المورقة + صالونة الدجاج / كورما الخضار",
    "desc_ar": "خبز بروتا مالابار الهش المورق مع مرق صالونة الدجاج المتبل على طريقة مطاعم الشوارع.",
    "state_ar": "تاميل نادو / كيرلا",
    "cuisine_ar": "وجبات شوارع تيفين الكلاسيكية",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "بروتا مالابار المورقة المقرمشة",
        "ingredients_ar": [
          [
            "دقيق أبيض",
            "2 cups"
          ],
          [
            "ملح",
            "1 tsp & 1/2 tsp"
          ],
          [
            "زيت",
            "4 tbsp"
          ],
          [
            "ماء",
            "3/4 cup"
          ]
        ],
        "quick_ar": "اعجن وافرد العجينة لطبقات رقيقة|اشوها مع السمن ثم صفقها باليدين لتتفكك الطبقات"
      },
      {
        "name_ar": "صالونة دجاج شوارع مادوراي",
        "ingredients_ar": [
          [
            "قطع دجاج",
            "400g"
          ],
          [
            "بصل شالوت صغير",
            "1 cup & 2 chopped"
          ],
          [
            "جوز الهند",
            "1/2 cup, 6 pcs & 1 tbsp ground to fine paste"
          ],
          [
            "معجون زنجبيل وثوم",
            "1.5 tbsp"
          ],
          [
            "جرام ماسالا",
            "1 tbsp each"
          ],
          [
            "أوراق كزبرة خضراء",
            "handful"
          ],
          [
            "زيت",
            "3 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اطبخ قطع الدجاج مع معجون جوز الهند وبذور الخشخاش والتوابل لمرق سائل عطري"
      }
    ]
  },
  "24": {
    "meal_ar": "بيتزا مارغريتا بالجبن + خبز بالثوم",
    "desc_ar": "بيتزا مارغريتا إيطالية كلاسيكية بجبن الموزاريلا وصلصة الطماطم مع أصابع الخبز بالثوم المقرمشة.",
    "state_ar": "إيطاليا",
    "cuisine_ar": "مطبخ إيطالي كلاسيكي",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "بيتزا مارغريتا بالجبن الكلاسيكية",
        "ingredients_ar": [
          [
            "Pizza Dough / Pizza Base",
            "1 base"
          ],
          [
            "طماطم",
            "1/2 cup"
          ],
          [
            "جبن",
            "1.5 cups"
          ],
          [
            "Fresh Basil & Oregano",
            "handful & 1 tsp"
          ],
          [
            "زيت",
            "1 tbsp"
          ],
          [
            "ملح",
            "to taste"
          ]
        ],
        "quick_ar": "افرد صلصة الطماطم على عجينة البيتزا|وزع جبن الموزاريلا وأوراق الريحان واخبز بالفرن حتى يذوب الجبن"
      },
      {
        "name_ar": "خبز بالثوم والزبدة المقرمش",
        "ingredients_ar": [
          [
            "خبز",
            "4 pcs"
          ],
          [
            "زبدة",
            "2 tbsp"
          ],
          [
            "ثوم",
            "1 tbsp"
          ],
          [
            "Oregano & Parsley",
            "1/2 tsp each"
          ],
          [
            "ملح",
            "pinch"
          ]
        ],
        "quick_ar": "ادهن الخبز بالزبدة والثوم والأعشاب واحمصه حتى يقرمش"
      }
    ]
  },
  "25": {
    "meal_ar": "مكرونة بالصلصة البيضاء الكريمة (ألفريدو) + توست بالثوم",
    "desc_ar": "مكرونة بيني بصلصة ألفريدو البيضاء الغنية بالجبن والزبدة مع شرائح خبز محمص بالثوم.",
    "state_ar": "إيطاليا",
    "cuisine_ar": "باستا إيطالية فاخرة",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "مكرونة بيني بالصلصة البيضاء (ألفريدو)",
        "ingredients_ar": [
          [
            "مكرونة",
            "200g boiled al dente"
          ],
          [
            "زبدة",
            "2 tbsp"
          ],
          [
            "دقيق أبيض",
            "2 tbsp"
          ],
          [
            "حليب",
            "2 cups"
          ],
          [
            "ثوم",
            "1 tbsp"
          ],
          [
            "فلفل رومي",
            "1/2 cup each sautéed"
          ],
          [
            "جبن",
            "1/2 cup grated"
          ],
          [
            "فلفل أسود",
            "1 tsp each"
          ],
          [
            "ملح",
            "to taste"
          ]
        ],
        "quick_ar": "اسلق المكرونة|حضر صلصة البشاميل من الزبدة والدقيق والحليب والجبن واخلط المكرونة"
      }
    ]
  },
  "26": {
    "meal_ar": "أرز مقلي بالخضار + جوبي منشوريا بالقرنبيط المقرمش",
    "desc_ar": "أرز مقلي على الطريقة الصينية مع زهرات قرنبيط مقرمشة بصلصة منشوريا الحامضة والحلوة.",
    "state_ar": "هندي صيني",
    "cuisine_ar": "مطبخ هندي صيني",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "أرز مقلي بالخضار في الووك",
        "ingredients_ar": [
          [
            "أرز",
            "3 cups"
          ],
          [
            "ثوم",
            "2 tbsp"
          ],
          [
            "جزر",
            "1.5 cups finely chopped"
          ],
          [
            "بصل",
            "1/2 cup"
          ],
          [
            "صلصة صويا",
            "1.5 tbsp"
          ],
          [
            "فلفل أسود",
            "1 tsp & 1/2 tsp"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "قلّب الخضار في مقلاة ووك ساخنة جداً|أضف الأرز البارد وصلصة الصويا والفلفل الأسود"
      },
      {
        "name_ar": "جوبي منشوريا بالقرنبيط المقرمش",
        "ingredients_ar": [
          [
            "قرنبيط",
            "250g"
          ],
          [
            "دقيق أبيض",
            "3 tbsp each"
          ],
          [
            "زنجبيل",
            "1 tbsp each"
          ],
          [
            "طماطم",
            "1 tbsp each"
          ],
          [
            "بصل",
            "1/4 cup"
          ],
          [
            "زيت",
            "for cooking"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اقلِ زهرات القرنبيط المغمورة بالعجين المقرمش|قلبها في مقلاة مع صلصة الصويا والشطة والثوم"
      }
    ]
  },
  "27": {
    "meal_ar": "دجاج حار صيني هندي (تشيلي تشيكن) + نودلز هاكا بالخضار",
    "desc_ar": "دجاج تشيلي مقرمش مع الفلفل الرومي والصويا صوص يُقدم مع نودلز هاكا المقلية بالخضار.",
    "state_ar": "البنغال الغربية",
    "cuisine_ar": "مأكولات هندية صينية غير نباتية",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "دجاج تشيلي على طريقة كلكتا",
        "ingredients_ar": [
          [
            "قطع دجاج",
            "400g"
          ],
          [
            "بيض",
            "2 tbsp & 1 egg white"
          ],
          [
            "صلصة صويا",
            "1.5 tbsp each"
          ],
          [
            "بصل",
            "1 cup each"
          ],
          [
            "زنجبيل",
            "1.5 tbsp each"
          ],
          [
            "فلفل أخضر حار",
            "4 pcs"
          ],
          [
            "بصل",
            "1/2 cup"
          ],
          [
            "زيت",
            "for cooking"
          ],
          [
            "ملح",
            "1/2 tsp each"
          ]
        ],
        "quick_ar": "اقلِ قطع الدجاج المتبلة|قلبها مع الفلفل الرومي والبصل والصويا وصلصة الشطة الحارة"
      },
      {
        "name_ar": "نودلز هاكا المقلية بالخضار",
        "ingredients_ar": [
          [
            "نودلز",
            "200g boiled al dente"
          ],
          [
            "جزر",
            "1.5 cups"
          ],
          [
            "ثوم",
            "1 tbsp"
          ],
          [
            "صلصة صويا",
            "1 tbsp each"
          ],
          [
            "زيت",
            "1 tbsp & 1/2 tsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اسلق النودلز وقلبها في الووك مع الخضار المقطعة وصلصة الصويا والخل"
      }
    ]
  },
  "28": {
    "meal_ar": "نودلز باد تاي التايلاندية المقلية + فول سوداني",
    "desc_ar": "نودلز الأرز التايلاندية المقلية بصلصة التمر هندي مع الفول السوداني المحمص وبراعم الفاصوليا.",
    "state_ar": "تايلاند",
    "cuisine_ar": "مأكولات شوارع تايلاند",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "نودلز باد تاي بانكوك المقلية",
        "ingredients_ar": [
          [
            "أرز",
            "200g"
          ],
          [
            "Firm Tofu (cubed)",
            "1/2 cup"
          ],
          [
            "تمر هندي",
            "2 tbsp each"
          ],
          [
            "صلصة صويا",
            "2 tbsp"
          ],
          [
            "بصل",
            "1 cup & 1/2 cup"
          ],
          [
            "ليمون",
            "3 tbsp & wedges"
          ],
          [
            "زيت",
            "2 tbsp"
          ]
        ],
        "quick_ar": "انقع نودلز الأرز واقلها مع التوفو والخضار وصلصة التمر هندي|زيّنها بالفول السوداني"
      }
    ]
  },
  "29": {
    "meal_ar": "وعاء رامن ياباني أصيل مع البيض المتبل",
    "desc_ar": "حساء رامن ياباني بمرق الصويا الغني ونودلز الرامن الطازجة وبيض متبل مطهو نصف استواء.",
    "state_ar": "اليابان",
    "cuisine_ar": "رامن ياباني أصيل",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "شوربة رامن شوكيو طوكيو",
        "ingredients_ar": [
          [
            "نودلز",
            "200g"
          ],
          [
            "Vegetable Broth",
            "3 cups"
          ],
          [
            "زيت",
            "3 tbsp & 1 tbsp"
          ],
          [
            "زنجبيل",
            "1 tsp each"
          ],
          [
            "زيت",
            "2 halves"
          ],
          [
            "Sweet Corn, Scallions, Nori Sheet",
            "for topping"
          ],
          [
            "ملح",
            "pinch"
          ]
        ],
        "quick_ar": "اغلِ مرق الصويا المتبل بالزنجبيل|ضع النودلز في وعاء واسكب المرق وأضف البيض المتبل"
      }
    ]
  },
  "30": {
    "meal_ar": "ساندويتش فلافل في خبز بيتا + حمص كريمي بالطحينة",
    "desc_ar": "حبات فلافل مقرمشة بالأعشاب داخل خبز بيتا دافئ مع حمص ناعم بالطحينة وسلطة طازجة.",
    "state_ar": "لبنان / الشرق الأوسط",
    "cuisine_ar": "مطبخ الشرق الأوسط",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "فلافل لبنانية مقرمشة",
        "ingredients_ar": [
          [
            "بازلاء",
            "1.5 cups"
          ],
          [
            "Parsley, Coriander & Mint",
            "1 cup chopped"
          ],
          [
            "بصل",
            "4 cloves & 1 chopped"
          ],
          [
            "مسحوق كزبرة",
            "1 tsp each"
          ],
          [
            "Baking Powder",
            "1/2 tsp"
          ],
          [
            "زيت",
            "2 cups"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اطحن الحمص المنقوع مع البقدونس والكزبرة والثوم|شكّلها واقلها بالزيت الساخن حتى تقرمش"
      },
      {
        "name_ar": "حمص كريمي ناعم مع خبز بيتا",
        "ingredients_ar": [
          [
            "زيت",
            "1.5 cups"
          ],
          [
            "Tahini (Sesame Paste)",
            "1/3 cup"
          ],
          [
            "ليمون",
            "2 tbsp"
          ],
          [
            "ثوم",
            "1 clove"
          ],
          [
            "خبز",
            "4 pcs"
          ],
          [
            "زيت",
            "2 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "اطحن الحمص المسلوق مع الطحينة وزيت الزيتون والليمون حتى ينعم|قدمه مع خبز بيتا"
      }
    ]
  },
  "31": {
    "meal_ar": "باف باجي مومباي بالزبدة + خبز باف محمص",
    "desc_ar": "مهروس خضار متبل بالزبدة على طريقة شوارع مومباي يُقدم مع أرغفة خبز باف محمصة بالزبدة.",
    "state_ar": "ماهاراشترا",
    "cuisine_ar": "مأكولات شوارع مومباي",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "باف باجي مومباي على الصاج",
        "ingredients_ar": [
          [
            "زيت",
            "3 cups mashed"
          ],
          [
            "بصل",
            "1 cup each finely chopped"
          ],
          [
            "طماطم",
            "4 finely chopped"
          ],
          [
            "معجون زنجبيل وثوم",
            "2 tbsp"
          ],
          [
            "Pav Bhaji Masala",
            "2.5 tbsp"
          ],
          [
            "Kashmiri Chilli Powder",
            "1.5 tbsp"
          ],
          [
            "زبدة",
            "75g"
          ],
          [
            "ليمون",
            "2 tbsp & 1/2 cup"
          ],
          [
            "حلبة مجففة",
            "1 tsp"
          ],
          [
            "ملح",
            "1.5 tsp"
          ]
        ],
        "quick_ar": "اسلق الخضار واهرسها على الصاج مع الزبدة وبهارات الباف باجي وعصير الليمون"
      },
      {
        "name_ar": "أرغفة خبز باف محمصة بالزبدة",
        "ingredients_ar": [
          [
            "أرغفة خبز باف",
            "6 pcs"
          ],
          [
            "زبدة",
            "3 tbsp"
          ],
          [
            "Pav Bhaji Masala & Coriander",
            "pinch for dusting"
          ]
        ],
        "quick_ar": "اقطع أرغفة الباف واحمّصها على الصاج مع الكثير من الزبدة"
      }
    ]
  },
  "32": {
    "meal_ar": "حمص شولي البنجابي الحار + خبز بهاتوري المنفوخ",
    "desc_ar": "حمص شولي أمريتساري المتبل بتوابل خاصة مع خبز بهاتوري ذهبي منتفخ ومقلي ومخلل فلفل.",
    "state_ar": "البنجاب / دلهي",
    "cuisine_ar": "مأكولات شوارع البنجاب",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "خبز بهاتوري بنجابي منفوخ",
        "ingredients_ar": [
          [
            "دقيق أبيض",
            "2 cups"
          ],
          [
            "سميد",
            "2 tbsp"
          ],
          [
            "زبادي رائب",
            "3 tbsp"
          ],
          [
            "Baking Powder & Soda",
            "1/2 tsp & 1/4 tsp"
          ],
          [
            "ملح",
            "1/2 tsp each"
          ],
          [
            "زيت",
            "3 cups"
          ]
        ],
        "quick_ar": "اعجن الدقيق مع الزبادي واتركه يرتاح|افرد دوائر كبيرة واقلها بالزيت الساخن حتى تنتفخ"
      },
      {
        "name_ar": "حمص شولي أمريتساري حار",
        "ingredients_ar": [
          [
            "بازلاء",
            "1.5 cups"
          ],
          [
            "بصل",
            "2 chopped & 2 pureed"
          ],
          [
            "معجون زنجبيل وثوم",
            "1.5 tbsp"
          ],
          [
            "مسحوق كزبرة",
            "1.5 tbsp & 1 tbsp"
          ],
          [
            "Amchur (Dry Mango Powder)",
            "1 tsp"
          ],
          [
            "Tea Bag (for dark color)",
            "1 pc"
          ],
          [
            "سمن بلدي",
            "2 tbsp"
          ],
          [
            "حلبة مجففة",
            "1 tsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اسلق الحمص مع كيس شاي أسود للون الغامق|اطبخه مع صلصة البصل والطماطم والبهارات الخاصة"
      }
    ]
  },
  "33": {
    "meal_ar": "تاكو مكسيكي بالجبن الذائب + جواكامولي + صلصة طماطم",
    "desc_ar": "قشور تاكو مقرمشة محشوة بالفاصوليا والجبن والصلصة مع جواكامولي الأفوكادو الطازج.",
    "state_ar": "المكسيك",
    "cuisine_ar": "مطبخ مكسيكي تقليدي",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "تاكو مكسيكي محشو بالجبن",
        "ingredients_ar": [
          [
            "Crispy Taco Shells / Tortillas",
            "6 pcs"
          ],
          [
            "فاصوليا خضراء",
            "1.5 cups seasoned with cumin & chilli"
          ],
          [
            "جبن",
            "1 cup"
          ],
          [
            "طماطم",
            "1 cup"
          ],
          [
            "زبادي",
            "3 tbsp"
          ],
          [
            "Salsa",
            "1/2 cup"
          ]
        ],
        "quick_ar": "املأ قشور التاكو المقرمشة بالفاصوليا المتبلة وصلصة الطماطم والجبن الذائب"
      },
      {
        "name_ar": "جواكامولي الأفوكادو الطازج",
        "ingredients_ar": [
          [
            "Ripe Avocados",
            "2 pcs"
          ],
          [
            "ليمون",
            "1 tbsp"
          ],
          [
            "بصل",
            "2 tbsp each"
          ],
          [
            "ملح",
            "1 tbsp & 1/2 tsp"
          ]
        ],
        "quick_ar": "اهرس الأفوكادو الناضج مع البصل المفروم والطماطم والليمون والكزبرة"
      }
    ]
  },
  "34": {
    "meal_ar": "باكورا البصل المقرمشة + شاي ماسالا هندي ساخن",
    "desc_ar": "شرائح بصل مقرمشة مقلية بدقيق الحمص مع كوب شاي كرك هندي متبل بالهيل والزنجبيل.",
    "state_ar": "تاميل نادو / جنوب الهند",
    "cuisine_ar": "وجبات خفيفة لشاي المساء",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "باكورا البصل المقرمشة",
        "ingredients_ar": [
          [
            "بصل",
            "3 large"
          ],
          [
            "Besan (Gram Flour)",
            "1 cup"
          ],
          [
            "أرز",
            "3 tbsp"
          ],
          [
            "Fennel Seeds (crushed)",
            "1 tsp"
          ],
          [
            "زنجبيل",
            "finely chopped"
          ],
          [
            "حلتيت",
            "1 tsp & 1/4 tsp"
          ],
          [
            "زيت",
            "1 tbsp"
          ],
          [
            "زيت",
            "2 cups"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اخلط شرائح البصل مع دقيق الحمص والكركم والفلفل الحار والماء القليل|اقلِ في زيت ساخن حتى تقرمش"
      },
      {
        "name_ar": "شاي كرك هندي بالهيل والزنجبيل",
        "ingredients_ar": [
          [
            "ماء",
            "1 cup & 1 cup"
          ],
          [
            "Strong Tea Dust / Leaves",
            "2 tsp"
          ],
          [
            "زنجبيل",
            "1 inch"
          ],
          [
            "هيل",
            "3 pods"
          ],
          [
            "سكر",
            "2 tsp"
          ]
        ],
        "quick_ar": "اغلِ الماء والحليب والشاي مع الزنجبيل الطازج والهيل المطحون حتى يغمق لونه"
      }
    ]
  },
  "35": {
    "meal_ar": "كاري سمك كانياكوماري بجوز الهند + أرز ماتا + سمك مقلي",
    "desc_ar": "كاري سمك ساحلي غني بحليب جوز الهند المتبل مع أرز ماتا الأحمر وسمك مقلي متبل.",
    "state_ar": "تاميل نادو / كيرلا",
    "cuisine_ar": "مأكولات ساحل كانياكوماري",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "كاري سمك كانياكوماري بجوز الهند",
        "ingredients_ar": [
          [
            "سمك",
            "500g"
          ],
          [
            "كمون",
            "1 cup & 1 tsp ground to smooth paste"
          ],
          [
            "بصل شالوت صغير",
            "12 & 6 cloves"
          ],
          [
            "طماطم",
            "2 chopped"
          ],
          [
            "عصير تمر هندي",
            "3 tbsp"
          ],
          [
            "مسحوق كزبرة",
            "2 tbsp & 1.5 tbsp"
          ],
          [
            "حلبة",
            "1/2 tsp each"
          ],
          [
            "زيت",
            "3 tbsp"
          ],
          [
            "أوراق كاري",
            "2 sprigs"
          ],
          [
            "ملح",
            "1.5 tsp"
          ]
        ],
        "quick_ar": "اطبخ السمك في قدر فخاري مع معجون جوز الهند والكمون والفلفل الحار والتمر هندي"
      },
      {
        "name_ar": "سمك مقلي متبل على طريقة ناغركويل",
        "ingredients_ar": [
          [
            "سمك",
            "300g"
          ],
          [
            "مسحوق فلفل أحمر",
            "1.5 tsp & 1/2 tsp"
          ],
          [
            "زنجبيل",
            "1 tsp & 1 tbsp"
          ],
          [
            "زيت",
            "3 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "تبّل شرائح السمك بالبهارات المحلية واقلها في المقلاة حتى تتحمر"
      },
      {
        "name_ar": "أرز ماتا الكيرلي المسلوق",
        "ingredients_ar": [
          [
            "أرز",
            "1.5 cups"
          ],
          [
            "ماء",
            "5 cups"
          ]
        ],
        "quick_ar": "اسلق أرز ماتا الأحمر التقليدي حتى ينضج تماماً"
      }
    ]
  },
  "36": {
    "meal_ar": "سمك بوليشاتو كيرلا في ورق الموز + أرز أبيض",
    "desc_ar": "سمك طازج متبل بالماسالا ومشوي ملفوفاً في أوراق الموز العطرية على طريقة كيرلا مع أرز.",
    "state_ar": "كيرلا",
    "cuisine_ar": "مأكولات بحرية كيرلا الكلاسيكية",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "سمك بوليشاتو مشوي في ورق الموز",
        "ingredients_ar": [
          [
            "سمك",
            "2 whole/steaks"
          ],
          [
            "بصل شالوت صغير",
            "1.5 cups"
          ],
          [
            "زنجبيل",
            "1.5 tbsp each"
          ],
          [
            "طماطم",
            "2 medium"
          ],
          [
            "فلفل أخضر حار",
            "2 sprigs & 3 slit"
          ],
          [
            "كركم",
            "1.5 tsp, 1/2 tsp, 1 tsp"
          ],
          [
            "تمر هندي",
            "1 piece / 1 tbsp"
          ],
          [
            "Fresh Banana Leaves",
            "2 softened over fire"
          ],
          [
            "زيت جوز الهند",
            "3 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "تبل السمك واقله نصف استواء|غلفه في ورق الموز مع خلطة البصل والبهارات واشوِ على الصاج"
      },
      {
        "name_ar": "أرز أبيض ساخن",
        "ingredients_ar": [
          [
            "أرز",
            "1.5 cups"
          ],
          [
            "ماء",
            "3.5 cups"
          ]
        ],
        "quick_ar": "أرز أبيض مطهو على البخار"
      }
    ]
  },
  "37": {
    "meal_ar": "آبام كيرلا التقليدي + يخنة خضار بحليب جوز الهند",
    "desc_ar": "فطائر آبام التقليدية المخمرة مع يخنة الخضار اللذيذة بحليب جوز الهند والتوابل الكاملة.",
    "state_ar": "كيرلا",
    "cuisine_ar": "مطبخ كيرلا التقليدي",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "فطائر آبام الهشة",
        "ingredients_ar": [
          [
            "أرز أبيض",
            "2 cups soaked"
          ],
          [
            "مبشور جوز الهند",
            "1 cup"
          ],
          [
            "أرز مطبوخ",
            "1/2 cup"
          ],
          [
            "Yeast / Fermentation agent",
            "1/2 tsp"
          ],
          [
            "ملح",
            "1 tbsp & 1 tsp"
          ]
        ],
        "quick_ar": "افرد العجينة المخمرة في مقلاة آبام المقعرة واطبخ على البخار حتى تنضج"
      },
      {
        "name_ar": "يخنة خضار خفيفة بحليب جوز الهند",
        "ingredients_ar": [
          [
            "بطاطس",
            "2 cups diced"
          ],
          [
            "حليب",
            "2 cups & 1 cup"
          ],
          [
            "بصل",
            "1 sliced, 1 tbsp minced, 3 slit"
          ],
          [
            "هيل",
            "1 inch, 3 pods, 4 pcs"
          ],
          [
            "زيت",
            "1.5 tbsp & 2 sprigs"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اسلق الخضار بحليب جوز الهند الخفيف وأضف الحليب المكثف وزيت جوز الهند"
      }
    ]
  },
  "38": {
    "meal_ar": "آبام كيرلا + إيدام البيض المشوي على طريقة مالابار",
    "desc_ar": "فطائر آبام الهشة مع إيدام بيض مشوي متبل بالبصل والطماطم والبهارات على طريقة مالابار.",
    "state_ar": "كيرلا / تاميل نادو",
    "cuisine_ar": "إفطار كيرلا غير النباتي",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "فطائر آبام الهشة",
        "ingredients_ar": [
          [
            "Appam Batter",
            "2 cups"
          ],
          [
            "ملح",
            "1/2 tsp each"
          ]
        ],
        "quick_ar": "افرد العجينة المخمرة في مقلاة آبام المقعرة واطبخ على البخار حتى تنضج"
      },
      {
        "name_ar": "إيدام البيض المشوي على طريقة مالابار",
        "ingredients_ar": [
          [
            "زيت",
            "4 slit lengthwise"
          ],
          [
            "بصل",
            "2.5 cups"
          ],
          [
            "طماطم",
            "2 large"
          ],
          [
            "معجون زنجبيل وثوم",
            "1.5 tbsp"
          ],
          [
            "Fennel Seeds (crushed)",
            "1 tsp"
          ],
          [
            "مسحوق كزبرة",
            "1.5 tbsp & 1 tbsp"
          ],
          [
            "فلفل أسود",
            "1/2 tsp & 1/2 tsp"
          ],
          [
            "زيت",
            "2 sprigs & 2 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "شوح البصل المفروم والطماطم والبهارات جيداً حتى تتكرمل|أضف البيض المسلوق المشرح وقلب"
      }
    ]
  },
  "39": {
    "meal_ar": "بوتو الأرز المبخر + كاري كادالا بالحمص الأسود + بابادوم",
    "desc_ar": "أسطوانات بوتو الأرز وجوز الهند المبخرة مع كاري الحمص الأسود الغني بالبهارات الكيرلية.",
    "state_ar": "كيرلا / تاميل نادو",
    "cuisine_ar": "مطبخ كيرلا التقليدي",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "بوتو الأرز وجوز الهند المبخر",
        "ingredients_ar": [
          [
            "أرز",
            "2 cups"
          ],
          [
            "مبشور جوز الهند",
            "1 cup"
          ],
          [
            "ملح",
            "3/4 cup & 1/2 tsp"
          ]
        ],
        "quick_ar": "بلل دقيق الأرز بالماء المالح|ضعه في أسطوانة البوتو بالتناوب مع مبشور جوز الهند واطبخ بالبخار"
      },
      {
        "name_ar": "كاري كادالا بالحمص الأسود المالاباري",
        "ingredients_ar": [
          [
            "بازلاء",
            "1.5 cups"
          ],
          [
            "جوز الهند",
            "1 cup coconut, fennel, coriander roasted dark brown & ground to paste"
          ],
          [
            "بصل شالوت صغير",
            "finely chopped"
          ],
          [
            "طماطم",
            "1 chopped"
          ],
          [
            "خردل",
            "for tempering"
          ],
          [
            "زيت جوز الهند",
            "2 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اسلق الحمص الأسود واطبخه مع معجون جوز الهند المحمص والبهارات حتى يثخن المرق"
      }
    ]
  },
  "40": {
    "meal_ar": "أفيال كيرلا بالخضار المشكلة وجوز الهند + أرز أحمر + كاري المورو",
    "desc_ar": "طبق أفيال الخضار المشكلة مع معجون جوز الهند والكمون وزيت جوز الهند وأرز مورو.",
    "state_ar": "كيرلا / تاميل نادو",
    "cuisine_ar": "وليمة الساديا الكيرلية",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "أفيال الخضار المشكلة بجوز الهند",
        "ingredients_ar": [
          [
            "بيض",
            "3 cups cut into 2-inch batons"
          ],
          [
            "كمون",
            "1.5 cups & 1 tsp coarsely ground"
          ],
          [
            "فلفل أخضر حار",
            "4 slit"
          ],
          [
            "زبادي رائب",
            "1/3 cup"
          ],
          [
            "زيت",
            "2 tbsp & 3 sprigs"
          ],
          [
            "كركم",
            "1/2 tsp"
          ],
          [
            "ملح",
            "1.5 tsp"
          ]
        ],
        "quick_ar": "اسلق تشكيلة الخضار|أضف معجون جوز الهند والكمون والفلفل والزبادي ورشة زيت جوز الهند وأوراق الكاري"
      },
      {
        "name_ar": "كاري المورو باللبن المخفوق",
        "ingredients_ar": [
          [
            "زبدة",
            "2 cups"
          ],
          [
            "بصل شالوت صغير",
            "minced"
          ],
          [
            "حلبة",
            "for tadka"
          ],
          [
            "زيت جوز الهند",
            "1 tbsp"
          ],
          [
            "ملح",
            "1/4 tsp & 1/2 tsp"
          ]
        ],
        "quick_ar": "سخن اللبن الرائب المخفوق مع الكركم ومعجون جوز الهند على نار هادئة وأضف طشة الخردل"
      },
      {
        "name_ar": "أرز أبيض ساخن",
        "ingredients_ar": [
          [
            "أرز",
            "1.5 cups"
          ],
          [
            "ماء",
            "3.5 cups"
          ]
        ],
        "quick_ar": "أرز أبيض مطهو على البخار"
      }
    ]
  },
  "41": {
    "meal_ar": "شكشوكة جبن البانير المبشور (بهورجي) + خبز فولكا بالقمح",
    "desc_ar": "جبن بانير مبشور ومقلي مع البصل والطماطم والفلفل الأخضر يقدم مع خبز فولكا الخفيف.",
    "state_ar": "شمال الهند",
    "cuisine_ar": "عشاء غني بالبروتين",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "شكشوكة جبن البانير المتبلة",
        "ingredients_ar": [
          [
            "جبن بانير",
            "300g"
          ],
          [
            "بصل",
            "2 medium"
          ],
          [
            "طماطم",
            "2 & 1/2 cup chopped"
          ],
          [
            "زنجبيل",
            "2 minced & 1 tbsp minced"
          ],
          [
            "كركم",
            "1/2 tsp, 1 tsp, 1/2 tsp"
          ],
          [
            "سمن بلدي",
            "2 tbsp"
          ],
          [
            "Fresh Coriander",
            "handful"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "قلّب البصل والطماطم والفلفل الأخضر|أضف جبن البانير المبشور والبهارات والكزبرة لدقائق معدودة"
      },
      {
        "name_ar": "خبز فولكا خفيف",
        "ingredients_ar": [
          [
            "دقيق قمح",
            "2 cups"
          ],
          [
            "ماء",
            "3/4 cup"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "أقراص خبز قمح كامل خفيفة ومنتفخة بدون زيت"
      }
    ]
  },
  "42": {
    "meal_ar": "سندال الحمص المسلوق المتبل + شاي كرك بالهيل",
    "desc_ar": "حمص مسلوق متبل بالخردل وأوراق الكاري ومبشور جوز الهند الطازج مع شاي كرك بالهيل.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "حلوى المعبد وشاي الكرك",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "سندال الحمص الأسود المتبل",
        "ingredients_ar": [
          [
            "زيت",
            "2 cups"
          ],
          [
            "مبشور جوز الهند",
            "1/2 cup"
          ],
          [
            "عدس أوراد",
            "1 tsp & 1 tsp"
          ],
          [
            "فلفل أخضر حار",
            "2 pcs & 1 slit"
          ],
          [
            "زنجبيل",
            "1/4 tsp & 1 tsp minced"
          ],
          [
            "أوراق كاري",
            "2 sprigs"
          ],
          [
            "زيت",
            "1 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اسلق الحمص الأسود وشوحه مع طشة الخردل وأوراق الكاري والفلفل الحار ومبشور جوز الهند"
      },
      {
        "name_ar": "شاي كرك هندي بالهيل والزنجبيل",
        "ingredients_ar": [
          [
            "ماء",
            "1 cup each"
          ],
          [
            "Tea Powder",
            "2 tsp"
          ],
          [
            "زنجبيل",
            "crushed"
          ],
          [
            "سكر",
            "2 tsp"
          ]
        ],
        "quick_ar": "اغلِ الماء والحليب والشاي مع الزنجبيل الطازج والهيل المطحون حتى يغمق لونه"
      }
    ]
  },
  "43": {
    "meal_ar": "بيض مسلوق ماسالا بالفلفل الأسود + خبز شباتي",
    "desc_ar": "بيض مسلوق محمص بخلطة بهارات تشيتي ناد والفلفل الأسود الغني مع خبز شباتي طازج.",
    "state_ar": "تاميل نادو / جنوب الهند",
    "cuisine_ar": "مطبخ ميليتري ميس العسكري",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "بيض مسلوق محمص بفلفل تشيتي ناد",
        "ingredients_ar": [
          [
            "زيت",
            "4 halved"
          ],
          [
            "بصل",
            "1 cup finely chopped"
          ],
          [
            "فلفل أسود",
            "1.5 tbsp"
          ],
          [
            "كمون",
            "1 tsp each"
          ],
          [
            "معجون زنجبيل وثوم",
            "1 tbsp"
          ],
          [
            "أوراق كاري",
            "2 sprigs"
          ],
          [
            "زيت سمسم",
            "2 tbsp"
          ],
          [
            "ملح",
            "1/4 tsp & 1 tsp"
          ]
        ],
        "quick_ar": "شرح البيض المسلوق وحمصه في المقلاة مع الفلفل الأسود والبصل والبهارات حتى يتحمر"
      },
      {
        "name_ar": "خبز شباتي بالقمح",
        "ingredients_ar": [
          [
            "دقيق قمح",
            "2 cups"
          ],
          [
            "ماء",
            "3/4 cup"
          ],
          [
            "زيت",
            "1 tbsp"
          ],
          [
            "ملح",
            "1/2 tsp"
          ]
        ],
        "quick_ar": "أرغఫة خبز شباتي طرية ومغذية بالقمح الكامل"
      }
    ]
  },
  "44": {
    "meal_ar": "بونغال الدخن الصحي + كوتو السبانخ والعدس",
    "desc_ar": "بونغال الدخن الطبيعي المطهو بالسمن والبهارات مع إيدام كوتو السبانخ والعدس المغذي.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "أطباق الدخن الصحية المتكاملة",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "بونغال الدخن بالسمن البلدي",
        "ingredients_ar": [
          [
            "حبوب الدخن",
            "1 cup"
          ],
          [
            "عدس ماش أصفر",
            "1/2 cup"
          ],
          [
            "سمن بلدي نقي",
            "3 tbsp"
          ],
          [
            "كمون",
            "1 tbsp each"
          ],
          [
            "زنجبيل",
            "1 tbsp & 10 pcs"
          ],
          [
            "حلتيت",
            "1 sprig & 1/4 tsp"
          ],
          [
            "ماء",
            "4.5 cups"
          ],
          [
            "ملح",
            "1.5 tsp"
          ]
        ],
        "quick_ar": "اسلق حبوب الدخن الصحي مع العدس الأصفر واخلطه مع طشة السمن والكاجو والفلفل"
      },
      {
        "name_ar": "إيدام كوتو السبانخ والعدس",
        "ingredients_ar": [
          [
            "سبانخ",
            "2 cups chopped"
          ],
          [
            "عدس أصفر (تور دال)",
            "1/2 cup boiled"
          ],
          [
            "كمون",
            "1/3 cup coconut & 1 tsp cumin ground"
          ],
          [
            "فلفل أحمر مجفف",
            "1 tsp & 1 pc"
          ],
          [
            "زيت",
            "1 tbsp"
          ],
          [
            "ملح",
            "1/4 tsp & 1 tsp"
          ]
        ],
        "quick_ar": "اسلق السبانخ مع العدس الأصفر ومعجون جوز الهند والكمون وأضف طشة الخردل"
      }
    ]
  },
  "45": {
    "meal_ar": "أوبما الشوفان الصحي بالخضار + شتني جوز الهند",
    "desc_ar": "شوفان صحي مطهو مع الخضار المشكلة وزيت الخردل يقدم مع شتني جوز الهند الطازج.",
    "state_ar": "صحي هندي تقليدي",
    "cuisine_ar": "إفطار غني بالألياف الصحية",
    "difficulty_ar": "سهل",
    "dishes_ar": [
      {
        "name_ar": "أوبما الشوفان الصحي بالخضار",
        "ingredients_ar": [
          [
            "شوفان",
            "1.5 cups"
          ],
          [
            "جزر",
            "1 cup finely diced"
          ],
          [
            "بصل",
            "1 chopped, 1 tsp minced, 2 slit"
          ],
          [
            "عدس أوراد",
            "1 tsp & 1 tsp"
          ],
          [
            "كاجو",
            "8 pcs"
          ],
          [
            "زيت",
            "1.5 tbsp"
          ],
          [
            "أوراق كاري",
            "for garnish"
          ],
          [
            "ماء",
            "2 cups"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "شوح الخضار مع البهارات|أضف رقائق الشوفان والماء واطبخ لدقائق حتى ينضج"
      },
      {
        "name_ar": "شتني جوز الهند الطازج",
        "ingredients_ar": [
          [
            "مبشور جوز الهند",
            "1 cup"
          ],
          [
            "حمص محمص مطحون",
            "2 tbsp"
          ],
          [
            "Green Chilli",
            "2"
          ],
          [
            "ملح",
            "for taste"
          ]
        ],
        "quick_ar": "اطحن جوز الهند مع الحمص والفلفل الأخضر|أضف طشة الخردل وأوراق الكاري"
      }
    ]
  },
  "46": {
    "meal_ar": "مادوراي كاري دوسا (دوسا بلحم الضأن المفروم)",
    "desc_ar": "فطائر دوسا شهية مغطاة بطبقة بيض ولحم ضأن مفروم متبل بالبهارات الحارة على طريقة مادوراي.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "مأكولات شوارع مادوراي الشهيرة",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "لحم ضأن مفروم متبل (كيما شوكا)",
        "ingredients_ar": [
          [
            "لحم ضأن",
            "250g"
          ],
          [
            "بصل شالوت صغير",
            "1 cup chopped"
          ],
          [
            "معجون زنجبيل وثوم",
            "1 tbsp"
          ],
          [
            "Fennel Seeds (Sombu)",
            "1 tsp"
          ],
          [
            "فلفل أسود",
            "1.5 tsp"
          ],
          [
            "مسحوق فلفل أحمر",
            "1 tsp each"
          ],
          [
            "أوراق كاري",
            "2 sprigs"
          ],
          [
            "زيت سمسم",
            "2 tbsp"
          ],
          [
            "ملح",
            "1 tsp"
          ]
        ],
        "quick_ar": "اطبخ لحم الضأن المفروم مع البصل والزنجبيل والتوابل حتى يجف ويتسبك تماماً"
      },
      {
        "name_ar": "كاري دوسا بطبقات البيض واللحم المفروم",
        "ingredients_ar": [
          [
            "Dosa Batter (Idli/Dosa Maavu)",
            "2 cups"
          ],
          [
            "بيض",
            "3 beaten"
          ],
          [
            "زيت",
            "3 tbsp"
          ],
          [
            "فلفل أسود",
            "for garnish"
          ]
        ],
        "quick_ar": "افرد عجينة دوسا سميكة على الصاج|ضع طبقة بيض مخفوق ثم لحم الكيما المفروم واقلب حتى تنضج"
      }
    ]
  },
  "47": {
    "meal_ar": "تشيتي ناد تشيكن سوكا (دجاج جاف ومحمص بالتوابل)",
    "desc_ar": "قطع دجاج محمصة بخلطة بهارات كارايكودي المحمصة الطازجة وأوراق الكاري والسمن.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "مطبخ تشيتي ناد الشهي",
    "difficulty_ar": "متوسط",
    "dishes_ar": [
      {
        "name_ar": "خلطة بهارات تشيتي ناد المحمصة",
        "ingredients_ar": [
          [
            "Coriander Seeds",
            "1.5 tbsp"
          ],
          [
            "فلفل أسود",
            "1.5 tbsp"
          ],
          [
            "كمون",
            "1 tsp each"
          ],
          [
            "فلفل أحمر مجفف",
            "5 pcs"
          ],
          [
            "Kalpasi (Stone Flower)",
            "1 small piece"
          ],
          [
            "قرنفل",
            "1 inch & 3 cloves"
          ]
        ],
        "quick_ar": "حمّص الكزبرة والفلفل الأسود والشمر والقرفة واطحنها ناعماً"
      },
      {
        "name_ar": "دجاج تشيتي ناد سوكا مقلي ومحمص",
        "ingredients_ar": [
          [
            "قطع دجاج",
            "500g"
          ],
          [
            "بصل شالوت صغير",
            "20 chopped"
          ],
          [
            "معجون زنجبيل وثوم",
            "1.5 tbsp"
          ],
          [
            "طماطم",
            "1 small chopped"
          ],
          [
            "أوراق كاري",
            "3 sprigs"
          ],
          [
            "زيت",
            "3 tbsp"
          ],
          [
            "ملح",
            "1 tsp & 1/2 tsp"
          ]
        ],
        "quick_ar": "حمّص قطع الدجاج مع البصل وأوراق الكاري وبهارات تشيتي ناد المطحونة طازجاً"
      }
    ]
  },
  "48": {
    "meal_ar": "حلوى تيرونلفيلي بالقمح والسمن البلدي",
    "desc_ar": "حلوى هندية ملكية تذوب في الفم محضرة من حليب القمح والسمن البلدي والكاجو المحمص.",
    "state_ar": "تاميل نادو",
    "cuisine_ar": "مطبخ تيرونلفيلي التراثي",
    "difficulty_ar": "صعب",
    "dishes_ar": [
      {
        "name_ar": "حليب قمح السامبا المستخلص",
        "ingredients_ar": [
          [
            "Whole Samba Wheat Berries (Godhumai)",
            "1 cup"
          ],
          [
            "ماء",
            "4 cups for extraction"
          ]
        ],
        "quick_ar": "انقع قمح السامبا 24 ساعة واطحنه واستخلص الحليب الأبيض المركز عبر مصفاة دقيقة"
      },
      {
        "name_ar": "حلوى تيرونلفيلي الأصلية بالسمن البلدي",
        "ingredients_ar": [
          [
            "حليب",
            "1 cup"
          ],
          [
            "سكر",
            "2 cups"
          ],
          [
            "سمن بلدي",
            "1 cup"
          ],
          [
            "كاجو",
            "15-20 pcs roasted in ghee"
          ],
          [
            "هيل",
            "1/2 tsp"
          ],
          [
            "سكر",
            "2 tbsp sugar + 1 tbsp water"
          ]
        ],
        "quick_ar": "اغلِ حليب القمح مع السكر|أضف السمن البلدي الصافي بالتدريج مع التقليب المستمر حتى تصبح لامعة ومطاطية"
      }
    ]
  }
};
